import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { LatestArticles } from "@/components/site/LatestArticles";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { useSeo } from "@/lib/seo";

const Index = () => {
  const description =
    "Adminlaget sköter löpande bokföring, ekonomi och administration åt föreningar i hela Sverige. Fast månadsavgift och en kontaktperson som svarar.";

  useSeo({
    title: "Bokföring & administration för föreningar | Adminlaget",
    description,
    canonical: "https://www.adminlaget.se/",
    ogType: "website",
    jsonLdId: "ld-org",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Adminlaget",
      url: "https://www.adminlaget.se/",
      description: "Bokföring och administration för ideella föreningar i Sverige",
      areaServed: "SE",
      serviceType: "Bokföringstjänst",
      slogan: "Bokföring & administration för föreningar",
    },
  });

  return (
    <main className="min-h-screen bg-paper text-ink">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <LatestArticles />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
